var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuikLogoIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        opacity: .7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.5,33.6l17.4-23.9-6.5,23.9,5.5,1.5-16.8,21.2,5.6-21.2-5.5-1.5h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.1,18.3h3l-2.7,3.7h-.3c-4.8,0-8.6,3.8-8.6,8.6v7.8c0,3,1.5,5.6,3.8,7.1l-1,3.7c-3.8-2-6.5-6.1-6.5-10.8v-7.8c0-6.8,5.5-12.3,12.3-12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.2,19.5l-1,3.5c2.5,1.5,4.3,4.3,4.3,7.5v7.8c0,4.8-3.8,8.6-8.6,8.6h-1.7l-2.7,3.7h4.3c6.8,0,12.3-5.5,12.3-12.3v-7.8c0-4.8-2.8-9-6.8-11h-.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuikLogoIco);
export default __webpack_public_path__ + "static/media/kuik-logo-ico.5bac26805a6cb0ea71173e4c909623a3.svg";
export { ForwardRef as ReactComponent };